<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent" ref="clickfarmingtable"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
		
		<importTable :ref="importRef" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import importTable from '@_system/components/import/index.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				importRef: Math.random(),
				modal_model:false,
				modal_title: '刷单数据',
				modal_width:1000,
				modal_height:800,
				list_formConfig: [{
					field: 'shopname',
					title: '店铺名称',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'psnNickName',
					title: '客服名称',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'dateId',
					title: '日期',
					itemRender: {
						name: '$datePicker',
						// props:{
						// 	type:'date'
						// }
					}
				}],
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			this.initImportConfig()
		},
		methods: {
			modal_init() {
				this.list_init()
			},	
			initImportConfig(){
				this.$refs[this.importRef].importcomfig = () => {
					return Promise.resolve([{
						code:'shopname',
						title: '店铺名称',
						require: true
					},{
						code:'psnNickName',
						title: '客服名称',
						require: true
					},{
						code:'clickfarmingamount',
						title: '刷单金额',
						require: true
					},{
						code:'dateId',
						title: '日期',
						require: true
					}])
				}
				this.$refs[this.importRef].importApi = () => {
					let data = this.$refs[this.importRef].importGetTableData()
					data = this.$refs[this.importRef].importTitle2Code(data)
					this.$api.BIsummary.updateclickfarming({
						data: data
					}).then(() => {
						this.$refs.clickfarmingtable.commitProxy('query')
						this.$refs[this.importRef].importNoticeShow = false
						this.$message.success('操作成功')
					})
				}
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.pagerConfig.enabled = true
				gridOptions.height = 650
				
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				},{
					name: '导入面板',
					status: 'warning',
					code: 'importdata'
				},{
					name: '批量删除',
					status: 'danger',
					code: 'deleteitem'
				}]
				gridOptions.columns = [{
						type: 'checkbox',
						title: '#',
						width:50,
					},{
						field: 'shopname',
						title: '店铺名称',
					},
					{
						field: 'psnNickName',
						title: '客服名称'
					},
					{
						field:'clickfarmingamount',
						title: '刷单金额',
					},
					{
						field: 'dateId',
						title: '日期',
					},
					{
						field: 'dateId',
						title: '日期',
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						slots: {
							default:({row})=>{
								return	[
										<el-button size="mini" type="text" style="color:#F56C6C;" onClick={()=>{this.deleteitem(row)}}>删除</el-button>,										
									]
							}
						}
					},
				]
				//gridOptions.formConfig = false
			},
			importdata() {
				this.$refs[this.importRef].importpanel()
			},
			list(page, updateForm, other) {
				return new Promise((resolve) => {
					this.$api.BIsummary.getclickfarming({
						...page,
						...updateForm,
						...other,
					}).then((res) => {
						resolve(res)
					},()=>{
						resolve({
							list: []
						})
					})
				})
			},
			deleteitem(row=null){
				let data = []
				if(row){
					data = [row.id]
				}else{
					data = this.$refs.clickfarmingtable.getCheckboxRecords().map((item)=>{
						return item.id
					})
				}
				if(data.length){
					this.$confirm('是否确认删除').then(()=>{
						this.$api.BIsummary.deleteclickfarming({
							id: data,
						}).then(() => {
							this.$refs.clickfarmingtable.commitProxy('query')
						})
					})
				}else{
					this.$message.error('请选择数据')
				}
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			importTable
		}
	}
</script>